import React, {Component}   from "react";
import {Button, Icon, Text} from "native-base";
import styles               from "../styles/Styles";

export default class NBButton extends Component {
    render() {
        if (this.props.iconType == "iconLeft")
            return (<Button iconLeft style={styles.button} onPress={this.props.onPress} >
                        <Icon name={this.props.icon} style={styles.buttonIcon} type={this.props.iconFamily} />
                        <Text style={styles.buttonText} uppercase={false}>{this.props.text}</Text>
                    </Button>);
        else if (this.props.iconType == "iconRight")
            return (<Button iconRight style={styles.button} onPress={this.props.onPress} >
                        <Text style={styles.buttonText} uppercase={false}>{this.props.text}</Text>
                        <Icon name={this.props.icon} style={styles.buttonIcon} type={this.props.iconFamily} />
                    </Button>);
        else
            return (<Button style={styles.button} onPress={this.props.onPress} >
                        <Text style={styles.buttonText} uppercase={false}>{this.props.text}</Text>
                    </Button>);
    }
}